/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import {ACCESS_TOKEN_KEY} from "../../utilities/Constants";

export async function searchAll(tableName,params) {
    const reqBody = {
        ...params,
        "ACCESS_TOKEN": {
            "S": JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY)).accessToken
        }
    };
    console.log('reqBody',reqBody);
    try {
        const url = process.env.REACT_APP_API_URL + "getall/"        
        const request = {
            method: "POST",
            body: JSON.stringify(reqBody)
        }
        let path;
        switch (tableName) {            
            case "TAGS":
                path = "tags"
                break
            default:
                throw new Error("BAD ENDPOINT");
        }
        const response = await fetch(url + path, request);
        const json = await response.json();
        console.log('json',json);
        if (json.statusCode && json.statusCode !== 200) {
            throw new Error("STATUS: " + json.statusCode);
        }
        return json;
    } catch (error) {
        console.log('got error',error);
        return {
            statusCode: 500,
            body: {
                message: error.message
            }
        }
    }
}
